const { default: axios } = require("axios");
import { createApp } from 'vue';
import Swiper from 'swiper';
import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';

var gap = document.getElementById("gap").clientWidth;
var gap2x = document.getElementById("gap-2x").clientWidth;
var mVert = document.getElementById("m-vert").clientWidth;
var mVertSlim = document.getElementById("m-vert-slim").clientWidth;
var widthMargin = document.getElementById("width-margin").clientWidth;
var articleWidth = document.getElementById("article-width").clientWidth;

window.addEventListener('load',function() {
    
    var ff = createApp({
        delimiters: ['${', '}'],
        data() {
            return {
                waitForApi: false,
            }
        },
        methods: {
        },
        computed: {
            isTouch: function() {
                return supportsTouch;
            }
        },
        mounted: function() {
        }
    }).mount('#app');

    new Swiper('.wp-block-ff-hero .swiper-container',{
        lazy: true,
        loop: true,
        autoplay: {
            delay: 2000,
        },
        on: {
            init: function() {
            },
            transitionEnd: function() {
            }
        },
        navigation: {
            prevEl: '',
            nextEl: ''
        },
        pagination: {
            el: '',
            type: 'bullets',
        },
    });

    if(document.getElementById("trigger")) {
        document.getElementById("trigger").addEventListener("click", function (el) {
            var el = document.getElementById("trigger");
            if (el.classList.contains("open")) {
                el.classList.remove("open");
                el.setAttribute("aria-expanded", "false");
                el.setAttribute("aria-label", "Menü öffnen");
                document.querySelector("body").classList.remove("scroll-lock");
                document.getElementById("mobile_menu").classList.remove("open");
            } else {
                el.classList.add("open");
                el.setAttribute("aria-expanded", "true");
                el.setAttribute("aria-label", "Menü schließen");
                document.querySelector("body").classList.add("scroll-lock");
                document.getElementById("mobile_menu").classList.add("open");
            }
        });
        this.document.querySelectorAll("#mobile_menu nav>ul>li.menu-item-has-children").forEach(function(el) {
            el.addEventListener("click", function(ev) {
                ev.preventDefault();
                var el = this;
                if (el.classList.contains("open")) {
                    el.classList.remove("open");
                } else {
                    document.querySelectorAll("#mobile_menu nav>ul>li.menu-item-has-children").forEach(function(el) {
                        el.classList.remove("open");
                    });
                    el.classList.add("open");
                }
            });
        });
    }

    this.document.querySelector(".open-quicklinks").addEventListener("click", function(ev) {
        ev.preventDefault();
        var ql = document.querySelector("#quicklinks");
        var btn = document.querySelector(".open-quicklinks");
        ql.classList.toggle("open");
        btn.setAttribute("aria-expanded", ql.classList.contains("open") ? "true" : "false");
    });

    this.document.querySelectorAll(".hb-accordion .title").forEach(function(el) {
        el.removeEventListener("click", function() {});
        el.addEventListener("click", function() {
            var btn = this;
            var accordion = btn.parentNode;
            if (accordion.classList.contains("is-open")) {
                accordion.classList.remove("is-open");
                btn.setAttribute("aria-expanded", "false");
            } else {
                document.querySelectorAll(".hb-accordion:not(.keep-open) .title").forEach(function(t) {
                    t.parentNode.classList.remove("is-open");
                    t.setAttribute("aria-expanded", "false");
                });
                accordion.classList.add("is-open");
                btn.setAttribute("aria-expanded", "true");
            }
        });
    });
    this.document.querySelectorAll(".wp-block-hb-ergebnisse .swiper-container").forEach(function(el) {
        new Swiper(el, {
            slidesPerView: 1.1,
            spaceBetween: 10,
            breakpoints: {
                768: {
                    slidesPerView: 2.1,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3.1,
                    spaceBetween: 20,
                },
            },
        })
    });

    this.document.querySelectorAll(".wp-block-button__link").forEach(function(el) {
        el.innerHTML = '<svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L8 8L2 14" stroke="#EA0005" stroke-width="3"/></svg><span>'+el.textContent.trim()+'</span>';
    });

    this.document.querySelectorAll(".hb-tab:not(.disabled)").forEach(function(el) {
        el.addEventListener("click", function() {
            var el = this;
            var id = el.getAttribute("data-id");
            document.querySelectorAll(".hb-tab").forEach(function(t) {
                t.classList.remove("is-active");
                t.setAttribute("aria-selected", "false");
            });
            el.classList.add("is-active");
            el.setAttribute("aria-selected", "true");
            document.querySelectorAll(".hb-tab__content").forEach(function(p) {
                p.classList.remove("is-active");
            });
            document.getElementById(id).classList.add("is-active");
        });
    });
})